export default {
  labels: {
    clients: { title: 'Clients', color: 'success' },
    important: { title: 'Important', color: 'danger' },
    social: { title: 'Social', color: 'info' },
    other: { title: 'Other', color: 'warning' },
  },
  messageDataPlaceholder: {
    subject: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore.',
    date: '3 days',
    content: `
      <p>Hi Mike,</p>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor 
        incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud 
        exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute 
        irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla 
        pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia 
        deserunt mollit anim id est laborum.
      </p>
      <blockquote class="blockquote">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor 
        incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud 
        exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute 
        irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla 
        pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia 
        deserunt mollit anim id est laborum.
      </blockquote>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor 
        incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud 
        exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute 
        irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla 
        pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia 
        deserunt mollit anim id est laborum.
      </p>`,

    sender: {
      avatar: 'img/avatars/6-small.png',
      name: 'Mae Gibson',
      email: 'mgibson@mail.com',
    },

    attachments: [
      { name: 'image_1.jpg', size: '527KB', path: 'img/bg/5.jpg' },
      { name: 'image_2.jpg', size: '269KB', path: 'img/bg/6.jpg' },
      { name: 'assignment_letter.pdf', size: '156KB', path: '/path/to/assignment_letter.pdf' },
      { name: 'app_update.zip', size: '1.35MB', path: '/path/to/app_update.zip' },
    ],
  },
  messagesListPlaceholder: [
    {
      id: 1,
      marked: false,
      label: 'social',
      unread: true,
      attachments: false,
      sender: 'Facebook',
      subject: 'Reset your account password',
      date: '1d ago',
    },
    {
      id: 2,
      marked: true,
      label: null,
      unread: false,
      attachments: false,
      sender: 'Mae Gibson',
      subject: 'Street Photography Competition',
      date: '1d ago',
    },
    {
      id: 3,
      marked: false,
      label: 'important',
      unread: false,
      attachments: false,
      sender: 'GitHub',
      subject: '[GitHub] Your password has been changed',
      date: '1d ago',
    },
    {
      id: 4,
      marked: true,
      label: 'clients',
      unread: true,
      attachments: true,
      sender: 'Nelle Maxwell',
      subject: 'New design concepts',
      date: '1d ago',
    },
    {
      id: 5,
      marked: false,
      label: null,
      unread: false,
      attachments: false,
      sender: 'Dropbox',
      subject: 'Complete your Dropbox setup',
      date: '1d ago',
    },
    {
      id: 6,
      marked: false,
      label: 'other',
      unread: false,
      attachments: false,
      sender: 'Task manager',
      subject: 'You have 5 overdue tasks!',
      date: '1d ago',
    },
    {
      id: 7,
      marked: false,
      label: 'social',
      unread: true,
      attachments: false,
      sender: 'Facebook',
      subject: 'Reset your account password',
      date: '1d ago',
    },
    {
      id: 8,
      marked: false,
      label: null,
      unread: false,
      attachments: false,
      sender: 'Mae Gibson',
      subject: 'Street Photography Competition',
      date: '1d ago',
    },
    {
      id: 9,
      marked: false,
      label: 'important',
      unread: false,
      attachments: false,
      sender: 'GitHub',
      subject: '[GitHub] Your password has been changed',
      date: '1d ago',
    },
    {
      id: 10,
      marked: false,
      label: 'clients',
      unread: true,
      attachments: true,
      sender: 'Nelle Maxwell',
      subject: 'New design concepts',
      date: '1d ago',
    },
    {
      id: 11,
      marked: true,
      label: null,
      unread: false,
      attachments: false,
      sender: 'Dropbox',
      subject: 'Complete your Dropbox setup',
      date: '1d ago',
    },
    {
      id: 12,
      marked: false,
      label: 'other',
      unread: false,
      attachments: false,
      sender: 'Task manager',
      subject: 'You have 5 overdue tasks!',
      date: '1d ago',
    },
    {
      id: 13,
      marked: false,
      label: 'social',
      unread: true,
      attachments: false,
      sender: 'Facebook',
      subject: 'Reset your account password',
      date: '1d ago',
    },
    {
      id: 14,
      marked: false,
      label: null,
      unread: false,
      attachments: false,
      sender: 'Mae Gibson',
      subject: 'Street Photography Competition',
      date: '1d ago',
    },
    {
      id: 15,
      marked: false,
      label: 'important',
      unread: false,
      attachments: false,
      sender: 'GitHub',
      subject: '[GitHub] Your password has been changed',
      date: '1d ago',
    },
    {
      id: 16,
      marked: false,
      label: 'clients',
      unread: true,
      attachments: true,
      sender: 'Nelle Maxwell',
      subject: 'New design concepts',
      date: '1d ago',
    },
    {
      id: 17,
      marked: false,
      label: null,
      unread: false,
      attachments: false,
      sender: 'Dropbox',
      subject: 'Complete your Dropbox setup',
      date: '1d ago',
    },
    {
      id: 18,
      marked: false,
      label: 'other',
      unread: false,
      attachments: false,
      sender: 'Task manager',
      subject: 'You have 5 overdue tasks!',
      date: '1d ago',
    },
    {
      id: 19,
      marked: false,
      label: 'social',
      unread: true,
      attachments: false,
      sender: 'Facebook',
      subject: 'Reset your account password',
      date: '1d ago',
    },
    {
      id: 20,
      marked: false,
      label: null,
      unread: false,
      attachments: false,
      sender: 'Mae Gibson',
      subject: 'Street Photography Competition',
      date: '1d ago',
    },
    {
      id: 21,
      marked: false,
      label: 'important',
      unread: false,
      attachments: false,
      sender: 'GitHub',
      subject: '[GitHub] Your password has been changed',
      date: '1d ago',
    },
    {
      id: 22,
      marked: false,
      label: 'clients',
      unread: true,
      attachments: true,
      sender: 'Nelle Maxwell',
      subject: 'New design concepts',
      date: '1d ago',
    },
    {
      id: 23,
      marked: false,
      label: null,
      unread: false,
      attachments: false,
      sender: 'Dropbox',
      subject: 'Complete your Dropbox setup',
      date: '1d ago',
    },
    {
      id: 24,
      marked: false,
      label: 'other',
      unread: false,
      attachments: false,
      sender: 'Task manager',
      subject: 'You have 5 overdue tasks!',
      date: '1d ago',
    },
    {
      id: 25,
      marked: false,
      label: 'social',
      unread: true,
      attachments: false,
      sender: 'Facebook',
      subject: 'Reset your account password',
      date: '1d ago',
    },
  ],
};
